import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  height: calc(100vh - 200px);
`;

export default Container;
